import { Navigate } from 'react-router-dom';
import Login from '../views/Login';

export const publicRoutes = [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/*',
    element: <Navigate to="/login" />,
  },
];
